import { render, staticRenderFns } from "./NewHalfMadeProductAdd.vue?vue&type=template&id=7b85a2ff"
import script from "./NewHalfMadeProductAdd.vue?vue&type=script&lang=js"
export * from "./NewHalfMadeProductAdd.vue?vue&type=script&lang=js"
import style0 from "./NewHalfMadeProductAdd.vue?vue&type=style&index=0&id=7b85a2ff&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports